export default "__VITE_ASSET__By6adGIN__"